import React from 'react';
import { IconFileAttachment } from 'jitsi/base/icons/svg';
import { AttachmentIcon } from './components/AttachmentIcon';
import { Container } from './components/Container';
import { Details } from './components/Details';
export const File = ({ name, ...containerProps }) => {
    return (React.createElement(Container, { ...containerProps },
        React.createElement(AttachmentIcon, { icon: IconFileAttachment, color: 'iisightBlue500' }),
        React.createElement(Details, { title: name, description: 'File' })));
};
